import client from './client';

export async function getReservationList(params) {
  const res = await client.get('/admin/reservation', { params });
  return res.data;
}

export async function getReservation(reservationId) {
  const res = await client.get(`/admin/reservation/${reservationId}`);
  return res.data;
}

/** 관리자가 전화 등으로 접수한 예약을 직접 등록 (기본 확정상태) */
export async function createReservation(payload) {
  const res = await client.post('/admin/reservation', payload);
  return res.data;
}

/** 예약 승인/거절/취소/노쇼/완료 처리 + 테이블 배정 */
export async function updateReservationStatus(reservationId, { reservationStatus, tableId, adminMemo, updatedBy }) {
  const res = await client.put(`/admin/reservation/${reservationId}/status`, { reservationStatus, tableId, adminMemo, updatedBy });
  return res.data;
}
